function envBase() {
  return (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
}

function ipv4Api() {
  return "http://127.0.0.1:8020";
}

function sameHostApi() {
  if (typeof window === "undefined") return "";
  const { hostname, port } = window.location;
  if (port !== "3020" && port !== "3000") return "";
  if (hostname === "localhost" || hostname === "127.0.0.1") return ipv4Api();
  return `http://${hostname}:8020`;
}

/** Prefer same-origin (CRA proxy), then IPv4 :8020. Never localhost→IPv6. */
function candidateBases() {
  const fromEnv = envBase();
  if (fromEnv) return [fromEnv];
  if (process.env.NODE_ENV === "production") return [""];
  const bases = ["", ipv4Api()];
  const lan = sameHostApi();
  if (lan && lan !== ipv4Api()) bases.push(lan);
  return bases;
}

export const API_BASE = envBase() || (typeof window !== "undefined" && window.location.port === "3020" ? ipv4Api() : "");

async function fetchOnce(base, path, { method = "GET", token, body, form } = {}) {
  const sep = path.includes("?") ? "&" : "?";
  const url = token
    ? `${base}${path}${sep}token=${encodeURIComponent(token)}`
    : `${base}${path}`;
  return fetch(url, {
    method,
    headers: form ? undefined : body ? { "Content-Type": "application/json" } : undefined,
    body: form ? form : body ? JSON.stringify(body) : undefined,
  });
}

export async function api(path, opts = {}) {
  const bases = candidateBases();
  let res;
  let lastNetworkError = null;
  for (const base of bases) {
    try {
      res = await fetchOnce(base, path, opts);
      lastNetworkError = null;
      break;
    } catch (err) {
      lastNetworkError = err;
    }
  }
  if (lastNetworkError || !res) {
    throw new Error(
      "Cannot reach TabletsTalk. Keep the API running on port 8020 and open the app on port 3020."
    );
  }
  if (res.headers.get("content-type")?.includes("image")) {
    if (!res.ok) throw new Error("Could not load photo");
    return res;
  }
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(res.ok ? "Unexpected server response" : `Server error (${res.status})`);
  }
  if (!res.ok) {
    const detail = data.detail;
    const msg =
      typeof detail === "string"
        ? detail
        : Array.isArray(detail)
          ? detail.map((d) => d?.msg || d).join(", ")
          : data.message || `Request failed (${res.status})`;
    throw new Error(msg);
  }
  return data;
}
